export default {
  default: {
    sideBarModalHeader: {
      title: 'Event',
      titleSecondLine: 'Calendars',
    },
  },
}
